import React, { useState, useEffect } from "react";
import deep from "../../Image/Deepesh pic.jpg"
import TechnologyExpertise from "../TechnologyExpertise";
import Tab from "../Tabs/Tab"
import Education from "./Education";
const AboutHomePage = (props) => {
 
  const [panel, setPanel] = useState()
  useEffect(() => {
   
    setPanel(1)
  }, [])
 
  const PanelRender = (data) => {
    setPanel(data)
  }
  const startDate = new Date(2021, 3, 8);// april 8th 2021
  const endDate = new Date(); // April 18th 2022
  const monthDiff =endDate.getMonth() -startDate.getMonth() +12 * (endDate.getFullYear() - startDate.getFullYear());
  console.log(monthDiff); // 27
  return (
    <center>
      <h3 className=" dark:text-[#FFF] text-[32px] font-bol ">About Me</h3>
      <div className="horizontal"></div>
      <Tab panel1={"Introduction"} panel2={"Education"} panelData={PanelRender} />
      <div>
        <div className={panel === 1 ? "flex flex-col  justify-center mt-8   lg:flex-row " : "hidden"}>
          <div className="lg:w-[45%] xl:w-[35%] lg:mt-32 border-[2px] border-[#17A6DB] dark:border-[#30dada]">
            <p className="dark:text-white text-[16px] py-4 px-4  md:text-[18pxl] lg:text-[20px] ">
              I am a qualified and professional Frontend developer with<span className="text-[#17A6DB] dark:text-[#30dada] font-bold"> {monthDiff}</span>  month of experience in website development.
              I’m a  located in India. I have a serious
              passion for UI effects, animations and creating intuitive, dynamic
              user experiences.  Well-organised person, problem solver, independent employee with
              high attention to detail.Interested in the entire frontend spectrum and working on
              ambitious projects with positive people.
            </p></div>
          <div className="lg:w-[45%] ">
            <div className="h-[218px]   w-[70%] lg:w-[45%] flex justify-center lg:h-[378px] lg:float-right lg:mr-16 b">
              <img src={deep} alt="" className=" h-[250px] lg:h-[450px] mt-4" /></div>
          </div>
        </div>
        <div className={panel === 2 ? "flex flex-col  justify-center mt-8   lg:flex-row " : "hidden"}>
          <Education />
        </div>
      </div>
     
    
        <div className=" mt-[100px] ">
          <TechnologyExpertise />
        </div>
     
    </center>
  );
};

export default AboutHomePage;
